module.exports = __webpack_public_path__ + "img/slider_11.f615ae33.jpg";